// extracted by mini-css-extract-plugin
export var picker = "_6-0";